import { NONE, TOTAL } from '../../../common/utils/constants'
import { disaggregations } from '../../../common/utils/enum'

const generatePieChartOptions = ({
  filteredIndicatorData,
  filteredAggregateData,
  indicatorMetadata,
  disaggregationCountries,
  selectedCountries,
  selectedComparison,
  disaggregationData,
  selectedAverage,
}) => {
  const data =
    filteredIndicatorData.length > 0
      ? filteredIndicatorData
      : filteredAggregateData

  const countries = [
    ...selectedCountries,
    ...new Set(filteredAggregateData.map((item) => item[disaggregations.RefArea])),
  ]

  const allYears = new Set(
    data.flatMap((d) => d.data?.xAxis?.map((x) => parseInt(x)) || [])
  )
  const chosenYear = Math.max(...allYears)

  // const comparisonDimensions = [
  //   'bondType',
  //   'issuerType',
  //   'dealSize',
  //   'currency',
  //   'tenorBucket',
  // ]

  let pieData

  if (selectedComparison === NONE) {
    const totalData = data
    pieData = countries
      ?.map((country) => {
        const countryData = totalData.find((d) => d[disaggregations.RefArea] === country)
        if (countryData) {
          const index = countryData.data.xAxis.findIndex(
            (x) => parseInt(x) === chosenYear
          )
          const value =
            index !== -1 ? parseFloat(countryData.data.yAxis[index]) : 0
          return {
            name:
              disaggregationCountries.find((c) => c.code === country)
                ?.description || country,
            y: value > 0 ? value : 0,
            unitMeasureCode: countryData?.[disaggregations.UnitMeasure],
          }
        }
        return null
      })
      .filter((item) => item !== null && item.y > 0)
  } else {
    let comparisonData =
      disaggregationData?.dimensions?.find(
        (item) => item.field_name === selectedComparison
      )?.field_value || []

    comparisonData = comparisonData.filter((item) => item.code !== TOTAL)

    pieData = comparisonData
      .map((category) => {
        const categoryData = data.filter(
          (d) => d[selectedComparison] === category.code
          // &&
          // comparisonDimensions.filter((otherDim) => otherDim !== dim)
          // .every((otherDim) => d[otherDim] === TOTAL)
        )
        const sumValue = categoryData.reduce((sum, d) => {
          const index = d.data.xAxis.findIndex(
            (x) => parseInt(x) === chosenYear
          )
          if (index !== -1) {
            const value = parseFloat(d.data.yAxis[index])
            return !isNaN(value) ? sum + value : sum
          }
          return sum
        }, 0)
        return {
          name: category.description,
          y: sumValue > 0 ? sumValue : 0,
          unitMeasureCode: categoryData?.[0]?.[disaggregations.UnitMeasure],
        }
      })
      .filter((item) => item.y > 0)
  }

  return {
    series: [
      {
        name: indicatorMetadata?.series_description?.name || '',
        data: pieData,
      },
    ],
  }
}

export default generatePieChartOptions
